var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.dataLoadFlag
      ? _c("div", { staticClass: "help-message" }, [_vm._v("Загрузка ...")])
      : !_vm.dataLoadFlag &&
        Object.keys(_vm.productsSelectedCategory).length === 0
      ? _c("div", { staticClass: "help-message" }, [
          _vm._v("\n        Нет продуктов.\n    ")
        ])
      : _c(
          "div",
          { staticClass: "material-grid-container" },
          _vm._l(_vm.productsSelectedCategory, function(product, productUUID) {
            return _vm.typeSelectedPlane === product.type && product.active
              ? _c(
                  "div",
                  {
                    staticClass: "material-grid-list",
                    on: {
                      click: function($event) {
                        return _vm.selectProduct(productUUID)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "material-grid-three-element-img-container material-img-container",
                        class: {
                          "active-photo":
                            productUUID === _vm.selectedProductUUID
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "material-grid-three-element-img",
                          attrs: { src: _vm.urlForPhoto(product.preview) }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "material-grid-three-element-text" },
                      [
                        _vm._v(
                          "\n          " + _vm._s(product.name) + "\n        "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          }),
          0
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }